'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.CtaTarget = exports.CtaStyle = void 0;
/**
 * Available styles for CTA
 */
var CtaStyle;
(function (CtaStyle) {
    CtaStyle["OPTIN"] = "optin";
    CtaStyle["LINK"] = "link";
    CtaStyle["BLUE"] = "blue";
    CtaStyle["GREEN"] = "green";
    CtaStyle["GREY"] = "grey";
    CtaStyle["ORANGE"] = "orange";
})(CtaStyle = exports.CtaStyle || (exports.CtaStyle = {}));
/**
 * Available targets for CTA
 */
var CtaTarget;
(function (CtaTarget) {
    CtaTarget["SELF"] = "_self";
    CtaTarget["NEW_TAB"] = "_blank";
    CtaTarget["PARENT"] = "_parent";
    CtaTarget["TOP"] = "_top";
})(CtaTarget = exports.CtaTarget || (exports.CtaTarget = {}));
